import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    filtersContainer: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(3),
      backgroundColor: theme.palette.grey[50],
    },
    filtersTitle: {
      marginBottom: theme.spacing(2),
      color: theme.palette.text.primary,
      fontWeight: 600,
    },
    buttonGroup: {
      display: 'flex',
      gap: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    filterButton: {
      minWidth: '100px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  })
);

export default useStyles;